import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getAllDetails } from '../../service/ProductService';
import AppBreadcrumb from '../../components/CustomeBreadcrumb/AppBreadcrumb';
import { USER_APPOINTMENTLIST } from '../../config/ApiConstant';
import { exportData, formatDateTime } from '../../appconfig/AppHelper';
import { defaultPageRowOptions, defaultRowOptions, paginatorLinks, showingEntries, SkeletonbodyTemplate, Skeletonitems } from '../../appconfig/Settings';
import { UserAppointmentListColumns } from '../../appconfig/DatatableSetting';
import { InputText } from 'primereact/inputtext';

export const UserAppointmentList = () => {
    document.title = "User's Appointment List | GSPC";

    // Parameters
    const { SlotId }: any = useParams();

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [appointmentList, setAppointmentList] = useState<any>([]);
    const [slotData, setSlotData] = useState<any>({});

    // useEffect
    useEffect(() => {
        getAllUsersAppointmentList();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Get all users appointment list
    const getAllUsersAppointmentList = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetails(USER_APPOINTMENTLIST + '?slot_id=' + atob(SlotId));
            if (response) {
                const DataList: any = response?.slot_details;
                setSlotData(response?.slot_data);
                if (DataList.length === 0) {
                    setAppointmentList([]);
                } else {
                    setAppointmentList(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(false);
                setAppointmentList([]);
            }
        } catch (error: any) {
            setPageLoad(false);
            setAppointmentList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button label="Export" icon="pi pi-file-export" onClick={() => exportCSV()} />
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="p-button-outlined p-button-primary ml-2"></Button>
            </>
        );
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // Export csv
    const exportCSV = () => {
        exportData('User_Appointment_List');
    };

    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'Dashboard'} pageName={"User's Appointment List"} pageTitle={"User's Appointment List"} goToPage={true} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <div className="grid">
                            <div className="field col-12 md:col-6 grid flex-column">
                                <div className="field col-12 grid">
                                    <div className="field col-4 col-md:4 mb-0">
                                        <b>Date </b>
                                    </div>
                                    <div className="field col-6 col-md:6 mb-0">: {!window.cn(slotData?.date) ? formatDateTime(slotData?.date) : ''}</div>
                                </div>

                                <div className="field col-12  grid">
                                    <div className="field col-4 col-md:4 mb-0">
                                        <b>Appointment Timing </b>
                                    </div>
                                    <div className="field col-6 col-md:6 mb-0">: {!window.cn(slotData?.slot_start_time) ? slotData?.slot_start_time + ' - ' + slotData?.slot_end_time : ''}</div>
                                </div>
                            </div>
                            <div className="field col-12 md:col-6 grid flex-column align-items-end ">
                                <div className="field col-12 md:col-6 mb-2 text-right">
                                    <b>Total Slots</b> : {!window.cn(slotData?.slot_total_members) ? slotData.slot_total_members : ''}
                                </div>
                                <div className="field col-12 md:col-6 mb-2 text-right">
                                    <b>Booked Slots</b> : {!window.cn(slotData?.booked_members) ? slotData?.booked_members : ''}
                                </div>
                                <div className="field col-12 md:col-6 mb-2 text-right">
                                    <b>Available Slots</b> : {!window.cn(slotData?.ava_slots) ? slotData?.ava_slots : ''}
                                </div>
                            </div>
                        </div>
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={appointmentList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    rows={defaultRowOptions}
                                    paginator={appointmentList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Appointments Found"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                >
                                    {UserAppointmentListColumns.map((col, i) => {
                                        if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {UserAppointmentListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
